import { useEffect, useState } from "react";
import {
  GetOrderByUniqueAttributeDocument,
  GetOrderByUniqueAttributeQuery,
} from "/@/generated/graphql";
import { useAuthContext } from "/@/shared/contexts/AuthContext";
import { useLazyQuery } from "@apollo/client";
type UseCreateOrderProps = {
  newOrderId?: string | undefined;
};

export const useCreateOrder = ({
  newOrderId,
}: Partial<UseCreateOrderProps> = {}) => {
  const { user } = useAuthContext();

  const [
    getExistingDraftOrder,
    {
      data: existingDraftOrderData,
      loading: existingDraftOrderLoading,
      refetch: originalRefetch,
    },
  ] = useLazyQuery(GetOrderByUniqueAttributeDocument, {
    fetchPolicy: "network-only",
  });

  const [order, setOrder] = useState<
    GetOrderByUniqueAttributeQuery["getOrderByUniqueAttribute"] | null
  >(null);

  const refetchOrder = async () => {
    const result = await originalRefetch();
    if (result.data?.getOrderByUniqueAttribute) {
      const orderDup = JSON.parse(
        JSON.stringify(result.data.getOrderByUniqueAttribute)
      );
      setOrder(orderDup);
    }
    return result;
  };

  useEffect(() => {
    if (newOrderId) {
      getExistingDraftOrder({
        variables: {
          where: {
            id: newOrderId,
          },
        },
      });
    }
  }, [newOrderId]);

  useEffect(() => {
    if (newOrderId && existingDraftOrderData) {
      const orderDup = JSON.parse(
        JSON.stringify(existingDraftOrderData.getOrderByUniqueAttribute)
      );
      setOrder(orderDup);
    }
  }, [existingDraftOrderData, existingDraftOrderLoading]);

  return {
    user,
    existingDraftOrderLoading,
    order,
    refetchOrder,
  };
};
